export default __webpack_public_path__ + "static/media/filter.34d3ceca.svg";